import { V3ProfileListItem, V3ProfileListItemProps } from "../V3ProfileListItem/V3ProfileListItem";
import { V3PinnedWrapper } from "./V3PinnedProfileItem.styles";

interface V3PinnedProfileItemProps extends V3ProfileListItemProps {}

export const V3PinnedProfileItem = ({ item, viewType, href, isPrivateView, responsiveBreakpoint }: V3PinnedProfileItemProps) => (
    <V3PinnedWrapper $viewType={viewType}>
        <V3ProfileListItem item={item} viewType={viewType} isPinned href={href} isPrivateView={isPrivateView} responsiveBreakpoint={responsiveBreakpoint} />
    </V3PinnedWrapper>
);
